module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-active-normal.97a7505d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-active-normal.png
// module id = 3431
// module chunks = 11